var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrimaryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-image 1",
    clipPath: "url(#clip0_217_1502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 5.25C12 6.07875 11.3287 6.75 10.5 6.75C9.67125 6.75 9 6.07875 9 5.25C9 4.42125 9.67125 3.75 10.5 3.75C11.3287 3.75 12 4.42125 12 5.25ZM16.875 13.5H15.75V12.375C15.75 11.754 15.2467 11.25 14.625 11.25C14.0033 11.25 13.5 11.754 13.5 12.375V13.5H12.375C11.7533 13.5 11.25 14.004 11.25 14.625C11.25 15.246 11.7533 15.75 12.375 15.75H13.5V16.875C13.5 17.496 14.0033 18 14.625 18C15.2467 18 15.75 17.496 15.75 16.875V15.75H16.875C17.4967 15.75 18 15.246 18 14.625C18 14.004 17.4967 13.5 16.875 13.5ZM12 11.25L8.30775 7.55775C7.2405 6.4905 5.5095 6.4905 4.44225 7.55775L2.25 9.75V4.125C2.25 3.09075 3.0915 2.25 4.125 2.25H11.625C12.6585 2.25 13.5 3.09075 13.5 4.125V8.625C13.5 9.246 14.0033 9.75 14.625 9.75C15.2467 9.75 15.75 9.246 15.75 8.625V4.125C15.75 1.851 13.8997 0 11.625 0H4.125C1.85025 0 0 1.851 0 4.125V11.625C0 13.899 1.85025 15.75 4.125 15.75H8.625C9.24675 15.75 9.75 15.246 9.75 14.625V14.25C9.75 13.0072 10.7572 12 12 12V11.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_1502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryIcon);
export default __webpack_public_path__ + "static/media/primaryIcon.40d9fbbc6e55b6685723300d356bf8fb.svg";
export { ForwardRef as ReactComponent };